export const PolicyType = Object.freeze({
  ADVANCED_CARE_PROGRAM: "ADVANCED_CARE_PROGRAM",
  CONSENT_TO_TREATMENT: "CONSENT_TO_TREATMENT",
  HIPAA: "HIPAA",
  PRIVACY: "PRIVACY",
  TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS",
});
